// Semester helpers for Progress Tracking.
// Stored semester values use the `Term-Year` convention (e.g. "Fall-2026",
// "Spring-2027", "Summer-2026"). Summers belong to the NEXT school year and use
// the school year's START year — the school year ends in June, so the summer that
// follows (June/July) is grouped with the upcoming year. For school year
// "2026-2027": Fall-2026, Spring-2027, Summer-2026.

export function parseSchoolYear(school_year) {
  const parts = String(school_year || "").split("-");
  const start = (parts[0] || "").trim();
  const end = (parts[1] || parts[0] || "").trim();
  return { start, end };
}

export function semesterOptions(school_year) {
  const { start, end } = parseSchoolYear(school_year);
  if (!start) return [];
  return [
    { value: `Fall-${start}`, label: `Fall ${start}` },
    { value: `Spring-${end}`, label: `Spring ${end}` },
    { value: `Summer-${start}`, label: `Summer ${start}` },
  ];
}

export function isSummerSemester(semester) {
  return /summer/i.test(semester || "");
}
